export const REQUEST_TECHNICIANS = "REQUEST_TECHNICIANS";
export const REQUEST_TECHNICIANS_SUCCEEDED = "REQUEST_TECHNICIANS_SUCCEEDED";
export const REQUEST_TECHNICIANS_FAILED = "REQUEST_TECHNICIANS_FAILED";

export const requestTechnicians = () => {
    return {
        type: REQUEST_TECHNICIANS,
    };
};

export const requestTechniciansSucceeded = (technicians) => {
    technicians = technicians.map((tech) => {
        var name = "";
        if (tech.firstName && tech.lastName) {
            var fName = tech.firstName[0].toUpperCase() + tech.firstName.substring(1);
            var lName = tech.lastName[0].toUpperCase() + tech.lastName.substring(1);
            name = fName + " " + lName;
        }

        tech["labourerName"] = name;

        return tech;
    });

    return {
        type: REQUEST_TECHNICIANS_SUCCEEDED,
        technicians,
    };
};

export const requestTechniciansFailed = () => {
    return {
        type: REQUEST_TECHNICIANS_FAILED,
    };
};
